import { usePropertiesStore } from '../../../../state-library/src'
import { MdOutlineChevronLeft, MdOutlineChevronRight } from 'react-icons/md'
import { composeClasses } from '@wiggot/utils/src/strings'
import { numberWithCommaWithoutDecimals } from '@wiggot/utils/src/formatters'
import { useMemo } from 'react'

interface Props {
  className?: string
}

const PropertyListPaginator = ({ className = '' }: Props): JSX.Element => {
  const { properties, propertyLoaderStatus, page, setPage } =
    usePropertiesStore()

  // const { setCopySearchingLoader, setLoaderVariant } = useBoundStore()

  const currentPage = useMemo<number>(() => page?.currentPage ?? 0, [page])
  const totalPages = useMemo<number>(() => page?.totalPages ?? 0, [page])
  const itemsPerPage = useMemo<number>(() => page.perpage, [page])
  const totalItems = useMemo<number>(() => page.totalItems, [page])

  const rangesCount = useMemo<{ from: number; to: number }>(() => {
    const page = currentPage - 1
    return {
      from: page * itemsPerPage + 1,
      to:
        page * itemsPerPage + itemsPerPage > totalItems
          ? totalItems
          : page * itemsPerPage + itemsPerPage,
    }
  }, [currentPage, itemsPerPage, totalItems])

  const prev = (): void => {
    setPage({
      ...page,
      currentPage: page.currentPage - 1,
    })
  }

  const next = (): void => {
    // setCopySearchingLoader(ESearchingLoaderCopy.SEARCH)
    // setLoaderVariant(ELoaderVariant.FROM_LISTINGS)
    setPage({
      ...page,
      currentPage: page.currentPage + 1,
    })
  }

  if (!properties?.length) {
    return <></>
  }

  return (
    <div
      className={composeClasses(
        'flex items-center justify-between w-full gap-3',
        className
      )}
    >
      <button
        type="button"
        disabled={currentPage <= 1 || propertyLoaderStatus.waitingAnimation}
        onClick={prev}
        className={`flex items-center ${
          page?.currentPage && page?.currentPage === 1 && 'text-gray'
        }`}
      >
        <MdOutlineChevronLeft className="w-6 h-6" /> Anterior
      </button>

      <p className="text-body-l font-bold text-text-primary">
        {numberWithCommaWithoutDecimals(rangesCount?.to)}{' '}
        <span className="text-body-l text-text-secondary">de </span>
        {numberWithCommaWithoutDecimals(totalItems)}
      </p>

      <button
        type="button"
        disabled={
          currentPage >= totalPages || propertyLoaderStatus.waitingAnimation
        }
        onClick={next}
        className={`flex items-center ${
          page?.totalPages && page?.totalPages === 1 && 'text-gray'
        }`}
      >
        Siguiente <MdOutlineChevronRight className="w-6 h-6" />
      </button>
    </div>
  )
}

export default PropertyListPaginator
